import moment from "moment";

const formatter = {
    formatNumber: function(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    
    formatDate: function(date) {
        let timestamp = date;
        if(timestamp < 1e12){
            timestamp = timestamp * 1000;        
        }
        let convertedDate = new Date(timestamp)

     return  moment(convertedDate).format('MMMM Do YYYY, HH:mm:ss a');
    },

    formatReportDate: function(date) {
      let convertedDate = moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
       return convertedDate;
    },

    // Compact date for tables — sale dates/payment dates can come back as
    // epoch seconds or an ISO string depending on the entity.
    formatShortDate: function(value) {
      if (!value) return '—';
      const date = typeof value === 'number' ? new Date(value * 1000) : new Date(value);
      return date.toLocaleDateString('en-RW', {
        year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit',
      });
    },
}

export { formatter }